import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item");
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_QueryFilterCpt = _resolveComponent("QueryFilterCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "customer-query-page"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_row, null, {
      default: _withCtx(() => [_createVNode(_component_van_col, {
        span: "6"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_van_dropdown_item, {
            modelValue: $data.searchTypeValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchTypeValue = $event),
            options: $data.searchTypes
          }, null, 8, ["modelValue", "options"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "12"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          class: "search",
          modelValue: $data.searchValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.searchValue = $event),
          name: "searchValue",
          placeholder: $options.searchFieldPh,
          rules: [{
            required: false,
            message: ''
          }]
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "3"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_button, {
          plain: "",
          style: {
            "width": "100%"
          },
          type: "primary",
          loading: $data.btnLoading,
          onClick: $options.onSearch
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["loading", "onClick"])]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "3"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_button, {
          plain: "",
          style: {
            "width": "100%"
          },
          type: "primary",
          onClick: $options.onFilterClick
        }, {
          default: _withCtx(() => [_createTextVNode(" 筛选 ")]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_van_divider, {
      style: {
        "margin": "0"
      }
    }), _createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm,
      onOnListDataChange: $options.onListDataChange
    }, {
      default: _withCtx(({
        item
      }) => [_createVNode(_component_van_cell, {
        "arrow-direction": "",
        "is-link": "",
        title: '姓名: ' + item.chnName,
        to: `/work-wx/customer/query/editor/${item.id}`
      }, {
        label: _withCtx(() => [_createVNode(_component_van_row, null, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("客户号: " + _toDisplayString(item.customerNo), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("客户级别: "), _createElementVNode("span", {
              style: _normalizeStyle({
                color: $options.getStatusStyle(item.levelType)
              })
            }, _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'levelType', {
              levelType: item.levelType
            })), 5)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("累计投资规模: " + _toDisplayString(item.investTotalAmount) + "元", 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("存续投资规模: " + _toDisplayString(item.existenceTotalAmount) + "元", 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["title", "to"])]),
      _: 1
    }, 8, ["request", "requestParameter", "onOnListDataChange"]), _createVNode(_component_QueryFilterCpt, {
      ref: "QueryFilterCpt",
      onOnFilterChange: $options.onFilterChange
    }, null, 8, ["onOnFilterChange"])]),
    _: 1
  });
}